module.exports = __webpack_public_path__ + "static/img/iconfont.6c66fc36.svg";